var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"CHATBOT_ROUTER",staticClass:"cahtbot_router"},[_c('div',{staticClass:"m-wrapper"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }